/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import openLinkIcon from "dc-icons/viewer2021/SDC_OpenLink_18_N.svg";
import { contextMenuPlacements, modernViewerDropinContext, VERB_OPEN_LINK } from "../constants/enums";
import { getCoordinatesRelativeToPage } from "utils/EventHandlingUtils";
import { openUrl } from "pdfActionManager";
import * as stores from "stores";
import { getHyperlinkUrl } from "../utils/UrlUtils";
import { pageContentHandler } from "../pageContentHandler";

class OpenHyperlinkBootstrap extends Component {
  getLabel = () => getMessage("contextMenu.modernViewer.openLink");

  getIcon = () => openLinkIcon;

  getTooltip = () => getMessage("contextMenu.modernViewer.openLink");

  getAriaLabel = () => getMessage("contextMenu.modernViewer.openLink");

  getPlacement = () => contextMenuPlacements.CONTEXT_MENU_BODY;

  id = VERB_OPEN_LINK;

  initializeAction = () => {};

  executeAction = (opts = {}) => {
    if (opts.context && opts.context === modernViewerDropinContext.CONTEXT_MENU) {
      const event = opts.contextMenuTriggerEventObj;
      const pageIndex = opts.pageIndex;
      const { x, y } = getCoordinatesRelativeToPage(event);
      let extraParams = pageContentHandler._hyperLinkManager.getCoordinatesRelativeToPDF(x, y, pageIndex, stores);
      getHyperlinkUrl(x, y, pageIndex)
        .then(url => {
          openUrl(url, extraParams);
        })
        .catch(err => {
          // Do nothing
        });
    }
  };

  render() {
    return null;
  }
}

export default OpenHyperlinkBootstrap;
